import React from 'react';
import PropTypes from 'prop-types';
import { isMobile } from 'common/helpers';
import PopOver from './PartnerHotels/PopOver';
import PopOverMobile from './PartnerHotels/PopOverMobile';
import Map from './PartnerHotels/Map';
import MapMobile from './PartnerHotels/MapMobile';
import Hotels from './PartnerHotels/Hotels';
import { hotelsMeta } from './constants';
import { arrayMergeByKey } from './helpers';
import { PartnerHotels as S } from './styles';

const content = {
  web: {
    header: {
      title: 'Official SWC Partner Hotels',
      desc: 'Attendees get exclusive discounts with our partner hotels.  After more top-end accommodation options? <br />Or after a budget option? Or a place for the squad to stay? We&apos;ve got you covered.',
    },
  },
  mobile: {
    header: {
      title: 'Official SWC <br />Partner Hotels',
      desc: 'Attendees get exclusive discounts with our partner hotels. ',
    },
  },
};

class PartnerHotels extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      selectedHotel: null,
    };
  }
  toggleModal = (modal) => {
    this.setState({ modal });
  };
  selectedHotel = (selectedHotel) => {
    this.setState({ selectedHotel });
  }
  renderMapWeb = (hotels) => {
    return (
      <Map
        containerElement={<S.MapWrapper />}
        mapElement={<div style={{ height: '100%', position: 'relative' }} />
        }
        hotels={hotels}
        modal={this.toggleModal}
        selectedHotel={this.selectedHotel}
      />
    );
  }
  renderMapMobile = (hotels) => {
    return (
      <MapMobile
        containerElement={<S.MapWrapper />}
        mapElement={<div style={{ height: '100%', position: 'relative' }} />
        }
        hotels={hotels}
        modal={this.toggleModal}
        selectedHotel={this.selectedHotel}
      />
    );
  }
  renderPopOver = (modal, selectedHotel) => {
    const modalProps = {
      visible: modal,
      onCancel: this.toggleModal,
      hotel: selectedHotel,
    };
    return (
      isMobile() ? (
        <PopOverMobile {...modalProps} />
      ) : (
        <PopOver {...modalProps} />
      )
    );
  }
  render() {
    const { modal, selectedHotel } = this.state;
    const hotels = arrayMergeByKey(this.props.hotels, hotelsMeta, 'name');
    const header = (isMobile() ? content.mobile.header : content.web.header);
    return (
      <S.Wrapper>
        <S.Header>
          <h1 dangerouslySetInnerHTML={{ __html: header.title }} />
          <p dangerouslySetInnerHTML={{ __html: header.desc }} />
        </S.Header>
        <S.Container>
          {isMobile() ? this.renderMapMobile(hotels) : this.renderMapWeb(hotels)}
          <Hotels hotels={hotels} modal={this.toggleModal} selectedHotel={this.selectedHotel} />
        </S.Container>
        {selectedHotel ? this.renderPopOver(modal, selectedHotel) : null}
      </S.Wrapper>
    );
  }
}

PartnerHotels.propTypes = {
  hotels: PropTypes.array.isRequired,
};

export default PartnerHotels;



// WEBPACK FOOTER //
// ./src/containers/Hotel/PartnerHotels.js